export const createHeadline = ({ headlineTitle }) => headlineTitle || 'SLEEP';
